import React, { useState, useEffect } from 'react'
import DebtManagement from './DebtManagement'
import DebtManagementDashboard from './DebtManagementDashboard'
import KPIDebtManagementDashboard from './KPIDebtManagementDashboard'
import KPILoanManagementDashboard from './KPILoanManagementDashboard'
import LoanDashboard from './LoanDashboard'
import LoanPortfolioReview from './LoanPortfolioDash/Main'
import PaymentsCollected from './PaymentsCollected'
import RevenueOperationalExpenses from './RevenueOperationalExpenses'
import BackLogo from '../../../../images/rewampimages/Chevron.png'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { getNBFCList } from './DebtListActionCreator'
import NPALeadsContainer from './NPALeads.container'
import { getProdcutList } from '../AdminActionCreator.component'
import { BorderRight } from '@mui/icons-material'
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';
import moment from 'moment'

const InitalDate = (type) => {


    if (type === 'fromDate') {
        const year = new Date().getFullYear();
        const FirstDay = moment(`${year}-01-01`);
        const fromdate = FirstDay.format('YYYY-MM-DD');
        // const fromdate = moment().subtract(1, 'month').format('YYYY-MM-DD');
        return fromdate
    } else if (type === 'toDate') {
        const todate = moment(new Date).format('YYYY-MM-DD')
        return todate
    }

}

export default function DebtListMain({ pageViewHandler, admin, allStatus, newDataBackground }) {
     const dispatch = useDispatch();
        const { fromDate:ReducerFrom, toDate:ReducerTo, nbfcId: ReducerNbfc, productId: ReducerProduct } = useSelector(state => state.FilterReduce.commonFilters);
    const [activeTab, setActiveTab] = useState('debtManagement')
    const [detailView, setDetailView] = useState(false)
    const [nbfcList, setnbfcList] = useState([])
    const [productList, setproductList] = useState([])

    const [commonFilters, setCommonFilters] = useState({
        fromDate: ReducerFrom,
        toDate: ReducerTo,
        nbfc: ReducerNbfc,
        product: ReducerProduct,
    })

     useEffect(() => {
            const obj = {
                fromDate: ReducerFrom,
        toDate: ReducerTo,
        nbfc: ReducerNbfc,
        product: ReducerProduct,
            }
            setCommonFilters(obj)
            
    
        }, [ReducerFrom, ReducerTo, ReducerNbfc, ReducerProduct]);


    const handleCommonFilters = (value, type) => {
         dispatch({ type: FILTER_ACTION, payload: { [type == "fromDate" ? "fromDate" : type == "toDate" ? "toDate" : type == "nbfc" ? "nbfcId" : type == "product" ? "productId" : ""]: e.target.value } });
        setCommonFilters((prev) => ({
            ...prev,
            [type]: value
        }))
    }

    const maxHeight = window.innerWidth > 1300 ? '60px' : '75px'
    const sectionStyle = {
        padding: (activeTab === 'debtManagement' || activeTab == 'KPILoanManagmentDashboard') && detailView == true ? '0px' : window.innerWidth > 1800 ? '20px' : '70px 20px'
    }
    const BackBtnStyle = {
        height: maxHeight,
        width: '100px',
        padding: '10px',
        textAlign: 'center',
        backgroundColor: '#006c67',
        color: '#fff',
        cursor: 'pointer',
    }

    const ActiveTabStyle = {
        backgroundColor: '#006c67',
        color: '#fff',
        borderRadius: '6px',
        fontSize: '12px'
    }
    const TabStyle = {
        fontSize: '12px'
    }

    useEffect(() => {
        getNBFCListAPI()
        getProdcutListApi()
    }, [])

    const getNBFCListAPI = () => {
        getNBFCList((callback) => {
            console.log(callback)
            if (callback) {
                setnbfcList(callback)
            } else {
                setnbfcList([])
            }
        })
    }

    const getProdcutListApi = () => {
        getProdcutList(callback => {
            setproductList(callback?.data)
        })
    }

    const handleTabs = (type) => {
        setActiveTab(type)
    }

    const detailViewHandler = (type) => {
        setDetailView(type)
    }

    return (
        <>
            <div className="DebtListMain">

                {
                    !detailView ?
                        <div className="details-new fixed-top">
                            <div className="row details-new-tab-div" style={{ display: 'flex', justifyContent: 'end' }} >
                                <div className="col-sm-3 " style={{ marginTop: '10px' }}>
                                    <img onClick={(e) => pageViewHandler(e, 'landingPage')} style={{ cursor: 'pointer', marginLeft: '8px' }} src={BackLogo} width={'30px'} /> <button style={{ color: '#1D3557', fontWeight: '700' }} onClick={(e) => pageViewHandler(e, 'landingPage')} >Back</button>
                                </div>
                                <div className="col-sm-9 col-xs-12" style={{ display: 'flex' }}>
                                    <div className="btn-group-new" style={{ marginLeft: 'auto', marginRight: '20px' }}>
                                        <button className={`NPATabStyle ${activeTab == 'debtManagement' ? "active" : ""}`} onClick={(e) => handleTabs('debtManagement')}>Debt <br /> Management</button>
                                        <button className={`NPATabStyle ${activeTab == 'KPIDebtManagement' ? "active" : ""}`} onClick={(e) => handleTabs('KPIDebtManagement')}>KPI Debt <br /> Managment</button>
                                        <button className={`NPATabStyle ${activeTab == 'KPILoanManagmentDashboard' ? "active" : ""}`} onClick={(e) => handleTabs('KPILoanManagmentDashboard')}>KPI Loan <br /> Managment</button>
                                        <button className={`NPATabStyle ${activeTab == 'Paymentscollected' ? "active" : ""}`} onClick={(e) => handleTabs('Paymentscollected')}>Payments <br /> collected</button>
                                        <button className={`NPATabStyle ${activeTab == 'LoanPortfolio' ? "active" : ""}`} onClick={(e) => handleTabs('LoanPortfolio')}>Loan Portfolio <br /> Review</button>
                                        {/* <button className={`NPATabStyle ${activeTab == 'RevenueOperation' ? "active" : ""}`} onClick={(e) => handleTabs('RevenueOperation')}>Revenue & Operational <br /> Expenses</button> */}
                                    </div>


                                </div>
                            </div>
                        </div>
                        : ''}
                <div className="Sections" style={sectionStyle}>

                    {
                        activeTab == 'debtManagement' || activeTab == 'KPILoanManagmentDashboard' ?
                            <NPALeadsContainer admin={admin} detailViewHandler={detailViewHandler} activeTab={activeTab} productList={productList}
                                handleCommonFilters={handleCommonFilters}
                                commonFilters={commonFilters}
                            />
                            // <DebtManagement nbfcList={nbfcList} />
                            : ''
                    }
                    {
                        activeTab == 'KPIDebtManagement' ?
                            <KPIDebtManagementDashboard nbfcList={nbfcList} productList={productList}
                                handleCommonFilters={handleCommonFilters}
                                commonFilters={commonFilters}
                            />
                            : ''
                    }
                    {
                        activeTab == 'DebtManagmentDashboard' ?
                            <DebtManagementDashboard />
                            : ''
                    }

                    {
                        activeTab == 'Paymentscollected' ?
                            <PaymentsCollected nbfcList={nbfcList} productList={productList}
                                handleCommonFilters={handleCommonFilters}
                                commonFilters={commonFilters}
                            />
                            : ''
                    }
                    {
                        activeTab == 'RevenueOperation' ?
                            <RevenueOperationalExpenses nbfcList={nbfcList} 
                            handleCommonFilters={handleCommonFilters}
                                commonFilters={commonFilters}
                            />
                            : ''
                    }
                    {
                        activeTab == 'LoanPortfolio' ?
                            <LoanPortfolioReview nbfcList={nbfcList} admin={admin} allStatus={allStatus} newDataBackground={newDataBackground} productList={productList}
                                handleCommonFilters={handleCommonFilters}
                                commonFilters={commonFilters}
                            />
                            : ''
                    }
                    {
                        activeTab == 'LoanDashboard' ?
                            <LoanDashboard />
                            : ''
                    }
                </div>

            </div>
        </>
    )
}
